export const SHIFT_REPORT_FILTER_SETTINGS_LIST = [
  {
    id: "by-shift-date-section",
    label: "By Shift Date",
    fields: [
      { id: "shiftDate", label: "By Shift Date" },
      { id: "shiftDateRange", label: "By Shift Date Range" },
      { id: "week", label: "Week" },
      { id: "month", label: "Month" },
      { id: "year", label: "Year" },
    ],
  },
  {
    id: "by-fleet-section",
    label: "By Fleet",
    fields: [
      { id: "fleetVendor", label: "By Fleet Vendor" },
      { id: "fleetNumber", label: "By Fleet Number" },
      { id: "fleetSize", label: "Fleet Size" },
    ],
  },
  {
    id: "by-delivery-associate-section",
    label: "By Delivery Associate",
    fields: [{ id: "driver", label: "DA Name" }],
  },
  {
    id: "by-rabbit-or-dolly-section",
    label: "By Rabbit or Dolly",
    fields: [
      { id: "rabbitSerial", label: "Rabbit Serial" },
      { id: "dollySerial", label: "Dolly Serial" },
    ],
  },
  {
    id: "by-user-created-or-updated-section",
    label: "By User Created or Updated",
    fields: [
      { id: "userCreated", label: "By User Created" },
      { id: "userUpdated", label: "By User Updated" },
    ],
  },
];

export const SHIFT_REPORT_TABLE_HEADERS_COLUMNS = [
  { field: "small", id: "week", label: "Week" },
  { field: "small", id: "shift_day", label: "Shift Day" },
  { field: "small", id: "date", label: "Date" },
  { field: "small", id: "station", label: "Station" },
  { field: "small", id: "created_by", label: "Created By" },
  { field: "small", id: "created_date", label: "Created Date" },
  { field: "small", id: "edited_by", label: "Edited By" },
  { field: "small", id: "last_updated", label: "Last Updated" },
  { field: "small", id: "shift-options", label: "" },
];

export const SHIFT_RECORD_TABLE_HEADERS_COLUMNS = [
  { field: "small", id: "id", label: "#", hasSort: true, table: [1] },
  { field: "small", id: "driver", label: "DA", hasSort: true, table: [1, 2] },
  { field: "small", id: "badge", label: "Badge", hasSort: true, table: [2] },
  { field: "small", id: "transporter_id", label: "Transporter ID", hasSort: true, table: [2] },
  { field: "small", id: "da_status", label: "DA Status", hasSort: true, table: [2] },
  { field: "small", id: "second_driver", label: "Helper", hasSort: true, table: [2] },
  {
    field: "small",
    id: "second_da_status",
    label: "Helper Status",
    hasSort: true,
    table: [2],
  },
  { field: "small", id: "role", label: "Shift Role", hasSort: true, table: [2] },
  { field: "small", id: "role_hours", label: "Hours", hasSort: true, table: [2] },
  { field: "small", id: "fleet_size", label: "Fleet Size", hasSort: true, table: [2] },
  { field: "small", id: "van", label: "Fleet No.", hasSort: true, table: [2] },
  { field: "small", id: "company", label: "Fleet Vendor", hasSort: true, table: [2] },
  { field: "small", id: "route", label: "Route", hasSort: true, table: [2] },
  { field: "small", id: "wave_time", label: "Wave", hasSort: true, table: [2] },
  { field: "small", id: "actual_DA", label: "Comment", hasSort: false, table: [2] },
  { field: "small", id: "rabbit_number", label: "Rabbit Serial", hasSort: true, table: [2] },
  { field: "small", id: "dolly_number", label: "Dolly Serial", hasSort: true, table: [2] },
  { field: "small", id: "ontime_attendance", label: "On time", hasSort: false, table: [2] },
  { field: "small", id: "launchpad_support", label: "LP Support", hasSort: false, table: [2] },
  {
    field: "small",
    id: "morning_checklist",
    label: "Fleet Inspection",
    hasSort: false,
    table: [2],
  },
  { field: "small", id: "number_of_stops", label: "Stops", hasSort: false, table: [2] },
  { field: "small", id: "number_of_packages", label: "Packages", hasSort: false, table: [2] },
  { field: "small", id: "number_of_pickups", label: "Pickups", hasSort: false, table: [2] },
  {
    field: "small",
    id: "number_of_completed_pickups",
    label: "Completed Pickups",
    hasSort: false,
    table: [2],
  },
  { field: "small", id: "actual_end_time", label: "End Time", hasSort: false, table: [2] },
  { field: "small", id: "rescue", label: "Rescue", hasSort: false, table: [2] },
  { field: "small", id: "uta", label: "UTA", hasSort: false, table: [2] },
  { field: "small", id: "utl", label: "UTL", hasSort: false, table: [2] },
  { field: "small", id: "nsl", label: "NSL", hasSort: false, table: [2] },
  { field: "small", id: "bc", label: "BC", hasSort: false, table: [2] },
  { field: "small", id: "otp_failure", label: "OTP Failure", hasSort: false, table: [2] },
  { field: "small", id: "missing", label: "Missing", hasSort: false, table: [2] },
  { field: "small", id: "damage", label: "Damage", hasSort: false, table: [2] },
  { field: "small", id: "missort", label: "Missort", hasSort: false, table: [2] },
  { field: "small", id: "fdd", label: "FDD", hasSort: false, table: [2] },
  { field: "small", id: "oc", label: "OC", hasSort: false, table: [2] },
  { field: "small", id: "others", label: "Other", hasSort: false, table: [2] },
  { field: "small", id: "delete", label: "", hasSort: false, table: [3] },
];

export const SHIFT_RECORD_TABLE_HADER_FILTER_COLUMNS = [
  {
    id: "stage-1",
    name: "Stage 1",
    subList: [
      { name: "Badge", paths: ["badge"] },
      { name: "Transporter ID", paths: ["transporter_id"] },
      { name: "DA Status", paths: ["da_status"] },

      {
        name: "Helper",
        subList: [
          { name: "Helper", paths: ["second_driver"] },
          { name: "Helper Status", paths: ["second_da_status"] },
        ],
      },

      { name: "Shift Role", paths: ["role"] },
      { name: "Hours", paths: ["role_hours"] },
      { name: "Fleet Size", paths: ["fleet_size"] },
      { name: "Fleet No.", paths: ["van"] },
      { name: "Fleet Vendor", paths: ["company"] },
      { name: "Route", paths: ["route"] },
      { name: "Wave", paths: ["wave_time"] },
      { name: "Comment", paths: ["actual_DA"] },
    ],
  },
  {
    id: "stage-2",
    name: "Stage 2",
    subList: [
      { name: "Rabbit Serial", paths: ["rabbit_number"] },
      { name: "Dolly Serial", paths: ["dolly_number"] },
      { name: "On time", paths: ["ontime_attendance"] },
      { name: "LP Support", paths: ["launchpad_support"] },
      { name: "Fleet Inspection", paths: ["morning_checklist"] },
    ],
  },
  {
    id: "stage-3",
    name: "Stage 3",
    subList: [
      { name: "Stops", paths: ["number_of_stops"] },
      { name: "Packages", paths: ["number_of_packages"] },
      { name: "Pickups", paths: ["number_of_pickups"] },
      { name: "Completed Pickups", paths: ["number_of_completed_pickups"] },
      { name: "End Time", paths: ["actual_end_time"] },
    ],
  },
  {
    id: "stage-4",
    name: "Stage 4",
    subList: [
      { name: "Rescue", paths: ["rescue"] },
      {
        name: "Return Reasons",
        paths: [
          "uta",
          "utl",
          "nsl",
          "bc",
          "otp_failure",
          "missing",
          "damage",
          "missort",
          "fdd",
          "oc",
          "others",
        ],
      },
    ],
  },
];

export const getShiftRecordTableColumns = (
  activeColumns: string[],
  tableNumber: number,
  width: number,
  hasSecondDriver: boolean,
) => {
  const visibleColumns = activeColumns?.length
    ? activeColumns
    : [
        "id",
        "driver",
        "badge",
        "is_status_published",
        "role",
        "fleet_size",
        "van",
        "route",
        "wave_time",
        "actual_DA",
        "delete",
      ];

  return SHIFT_RECORD_TABLE_HEADERS_COLUMNS.filter((col) => visibleColumns.includes(col.id)).filter(
    (col) => {
      if (!hasSecondDriver && ["second_driver", "second_da_status"].includes(col.id)) return false;
      if (!col.table.includes(tableNumber)) return false;
      if (width < 840 && tableNumber === 1) return col.id !== "driver";
      if (width > 840 && tableNumber === 2) return col.id !== "driver";
      return true;
    },
  );
};
